import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './core/home/home.component';
import {BadRequestComponent} from './core/badrequest/badrequest.component';
import { environment } from '../environments/environment';
import { AutoLoginAllRoutesGuard } from 'angular-auth-oidc-client';

export const MODULE_ANAGRAFICA = 'anagrafica';
export const MODULE_CONFIGURAZIONE = 'configurazione';
export const MODULE_GEO = 'geo';
export const MODULE_SIPER = 'siper';

const appRoutes: Routes = [

  { path: 'bad-request', component: BadRequestComponent },
  { 
    path: '', 
    component: HomeComponent,
    canActivate: (environment.oidc.enable === 'true')?[AutoLoginAllRoutesGuard]:[] 
  },
  { path: MODULE_ANAGRAFICA, loadChildren: () => import('./+anagrafica/anagrafica.module').then(m => m.AnagraficaModule)},
  { path: MODULE_CONFIGURAZIONE, loadChildren: () => import('./+configurazione/configurazione.module').then(m => m.ConfigurazioneModule)}

];

@NgModule({
  imports: [
    // RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules})
    RouterModule.forRoot(appRoutes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
